<div class="header_search">
  <div class="title-page">
    <h3>Agenda Positiva</h3>
  </div>
  <div class="content_search">
    <div class="new-project btn-new">
      <a [href]="novaUrl" target="_blank" class="btn btn-primary" type="btn" *ngIf="canCreateAgendaPos">Nova agenda</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th>Agenda</th>
          <th>Órgão</th>
          <th>Status SECOM</th>
          <th>Tag mapa</th>
          <th>Município</th>
          <th>Título</th>
          <th class="text-center">Data</th>
          <th class="text-center btn-icon-td">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let agenda of agendaList; let i = index">
          <tr>
            <td class="title">{{ agenda?.id }}</td>
            <td>{{ agenda?.str_sigla }}</td>
            <td>{{ agenda?.str_secom_status }}</td>
            <td>{{ agenda?.tag_mapa_name }}</td>
            <td>
              <div *ngIf="agenda?.other_location != null && agenda?.other_location != ''; else city">
                <div>
                  Fora do Estado<br> {{agenda?.other_location}}
                </div>
              </div>
              <ng-template #city>
                {{agenda?.city}}
              </ng-template>
            </td>
            <td>{{ agenda?.title }}</td>
            <td class="text-center">{{ agenda?.dt_done }}</td>
            <td>
              <div class="btn-icon">
                <span class="icon-table" (click)="editar(agenda?.id)">
                  <img src="assets/images/svgs/editar1.svg" alt="Editar" tooltip="Editar" placement="bottom">
                </span>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="agendaList?.length == 0" class="border-b-radius">
          <td colspan="10" class="text-center">Nenhum Agendamento Cadastrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>